<template>
  <FiltersWatcher
    :filters="filters"
    v-on="$listeners"
  >
    <SectionGroup gap="larger">
      <FormSection title="Специализация">
        <SpecsPicker
          :groups="groups"
          :selected-categories="filters.specialization_ids"
          :s-options="options.specialization_ids"
          v-model="filters.specialization_ids"
          :allow-select-group="true"
          :max-selected-categories-count="null"
        />
      </FormSection>
      <FormSection title="Квалификация">
        <InputGroup direction="vertical" gap="medium">
          <BasicCheckbox
            v-for="option in options.qualifications"
            v-model="filters.qualifications"
            :value="option.value"
            :key="option.title"
          >
            {{ option.title }}
          </BasicCheckbox>
        </InputGroup>
      </FormSection>

      <FormSection title="Профессиональные навыки">
        <SkillsPicker
          v-model="filters.skill_ids"
          :skills.sync="dynamicOptions.skill_ids"
        />
      </FormSection>
      
      <FormSection title="Вознаграждение">
        <InputRangeGroup
          dropdown
          :from.sync="filters.salaryFrom"
          :to.sync="filters.salaryTo"
          :measure.sync="filters.currency"
          :measure-options="options.currency"
        />
      </FormSection>
      <FormSection title="Хабы">
        <SectionGroup gap="medium">
          <HabrHubsPicker
            v-model="filters.hubs"
            multiple
            :hubs.sync="dynamicOptions.hubs"
          />
          <BasicCheckbox
            v-model="filters.onlyContributedHubs"
            :disabled="filters.hubs.length === 0"
            :value="1"
          >
            Искать по хабам, куда есть вклад
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Местоположение">
        <SectionGroup gap="medium">
          <HabrLocationPicker
            v-model="filters.locations"
            multiple
            :locations.sync="dynamicOptions.locations"
          />
          <BasicCheckbox
            v-model="filters.excludeLocations"
            :disabled="filters.locations.length === 0"
            :value="1"
          >
            Исключить из поиска
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Компания">
        <SectionGroup gap="medium">
          <HabrCompanyPicker
            v-model="filters.companies"
            multiple
            :companies.sync="dynamicOptions.companies"
          />
          <BasicCheckbox
            v-model="filters.excludeCompanies"
            :disabled="filters.companies.length === 0"
            :value="1"
          >
            Исключить из поиска
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>

      <FormSection title="Активность на сайте">
        <BasicSelect
          v-model="filters.activityPeriod"
          :options="options.activityPeriod"
        />
      </FormSection>
  
      <slot name="controls" />
    </SectionGroup>
  </FiltersWatcher>
</template>

<script>
  import FiltersWatcher from 'src/components/filters/FiltersWatcher/FiltersWatcher.vue';
  import BasicCheckbox from 'src/components/form/BasicCheckbox/BasicCheckbox.vue';
  import BasicSelect from 'src/components/form/BasicSelect/BasicSelect.vue';
  import FormSection from 'src/components/form/FormSection/FormSection.vue';
  import InputGroup from 'src/components/form/InputGroup/InputGroup.vue';
  import InputRangeGroup from 'src/components/form/InputRangeGroup/InputRangeGroup.vue';
  import HabrCompanyPicker from 'src/components/pickers/HabrCompanyPicker/HabrCompanyPicker.vue';
  import HabrHubsPicker from 'src/components/pickers/HabrHubsPicker/HabrHubsPicker.vue';
  import HabrLocationPicker from 'src/components/pickers/HabrLocationPicker/HabrLocationPicker.vue';
  import SkillsPicker from 'src/components/pickers/SkillsPicker/SkillsPicker.vue';
  import SpecsPicker from 'src/components/pickers/SpecsPicker/SpecsPicker.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

  export default {
    name: 'HabrResumeFilters',
    components: {
      InputRangeGroup,
      FiltersWatcher,
      HabrCompanyPicker,
      HabrLocationPicker,
      HabrHubsPicker,
      BasicCheckbox,
      FormSection,
      SectionGroup,
      SpecsPicker,
      BasicSelect,
      SkillsPicker,
      InputGroup,
    },
    props: {
      filters: {
        type: Object,
        required: true,
      },
      options: {
        type: Object,
        required: true,
      },
      dynamicOptions: {
        type: Object,
        required: true,
      },
      groups: {
        type: Array,
        required: true,
      }
    },
  }
</script>